import apiClient from '../../apiClient';

export const fetchWelcomeText = async (language) => {
  try {
    const response = await apiClient.post('/home/welcome_text/', {
      language,
    });
    
    return {
      welcomeMessage: response.data.Title,
      description: response.data.Description,
    };
  } catch (error) {
    console.error('Error fetching welcome text:', error);
    throw error;
  }
};
